
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.6 16.081H13.533c-.616 0-1.099.537-1.002 1.12l1.569 10.12c.072.478.495.829 1.002.829h14.917c.495 0 .93-.35 1.002-.829l1.569-10.12c.096-.583-.374-1.12-.99-1.12z","fill":"#52A728"}}),_c('path',{attrs:{"d":"M16.248 33.343c1.153 0 2.088-.904 2.088-2.019 0-1.115-.935-2.02-2.088-2.02s-2.088.905-2.088 2.02.935 2.02 2.088 2.02zm12.782 0c1.153 0 2.088-.904 2.088-2.019 0-1.115-.935-2.02-2.088-2.02s-2.088.905-2.088 2.02.935 2.02 2.088 2.02zM16.936 13.956h-6.24c-.47 0-.857-.373-.857-.828 0-.456.387-.84.87-.84h6.24c.47 0 .856.373.856.828 0 .455-.386.84-.869.84z","fill":"#A8D393"}})])
          )
        }
      }
    